import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};
export default function AccountSidebar({ children }: Props) {
  return (
    <div className="w-80 xl:w-90  card flex flex-col h-full items-center overflow-y-auto shrink-0">
      <div className="card-inner-light dark:bg-gradient-to-br from-accent-muted/30 to-40% h-100" />
      {children}
    </div>
  );
}
